import { type ForwardedRef, forwardRef } from 'react';
import type { OptionTypeBase, Props as ReactSelectProps } from 'react-select';

import { BaseSelect } from './BaseSelect';
import { SelectType } from './SelectType';
import type { CustomizeMenuPortaling } from './types';

// Modified from: https://codesandbox.io/s/648uv?file=/chakra-react-select.js

export type SelectProps<
  OptionType extends OptionTypeBase = { label: string; value: string },
  IsMulti extends boolean = false,
> = CustomizeMenuPortaling<ReactSelectProps<OptionType, IsMulti>>;

export const Select = forwardRef(
  <OptionType extends OptionTypeBase, IsMulti extends boolean>(
    props: SelectProps<OptionType, IsMulti>,
    forwardedRef: ForwardedRef<unknown>,
  ) => (
    <BaseSelect
      customRef={forwardedRef}
      selectType={SelectType.STANDARD}
      selectProps={props}
    />
  ),
);
Select.displayName = 'Select';
